import { Client } from './client';

export enum UserRole {
  Admin = 'admin',
  User = 'user',
  Manager = 'manager',
  Warehouse = 'warehouse',
  Customer = 'customer'
}

export interface User {
  id: number;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  role: UserRole;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  lastLoginAt?: string;
  client?: Client;
  clientId?: number;
}
